import { Button, Drawer, Select, TextInput } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import styled from 'styled-components';
import ControlTrad from '../assets/trad/ControlTrad';

const HeadMain = styled.div`
  display: flex;
  flex-direction:column;
  *{margin: 5px 0;}
`;

const HeaderFiltersDrawer = (props) => {
    const [opened, { open, close }] = useDisclosure(false);
    return (
        <>
            <Button onClick={(e) => { open(e); window.history.pushState({ filtros: true }, 'Filtros'); }}>
                {ControlTrad.getTrad("filtros")}
            </Button>
            <Drawer
                opened={opened}
                size="md"
                onClose={close}
                title={ControlTrad.getTrad("filtros")}
                overlayProps={{ opacity: 0.5, blur: 4 }}
                position="top"
            >
                <div>
                    <HeadMain>
                        <TextInput
                            variant="filled"
                            id={'buscador'}
                            value={props?.searchTerm}
                            placeholder={ControlTrad.getTrad("search")}
                            onInput={(e) => props?.setSearchTerm(e.target.value)}
                            label={ControlTrad.getTrad("search")}
                        />
                        <Select
                            onChange={(e) => props?.setFilterType(e)}
                            value={props?.filterType}
                            defaultValue={''}
                            data={[{ value: '', label: ControlTrad.getTrad("fontsAll") }, { value: "1", label: ControlTrad.getTrad("fontBeure") },
                            { value: "2", label: ControlTrad.getTrad("fontBeureSing") }, { value: "3", label: ControlTrad.getTrad("fontGossos") },
                            { value: "4", label: ControlTrad.getTrad("fontAccesible") },
                            ]}
                            allowDeselect={false}
                            label={ControlTrad.getTrad("typeFont")}

                        />
                        <TextInput
                            variant="filled"
                            type="number"
                            id={'buscador'}
                            value={props?.maxDistance}
                            placeholder={ControlTrad.getTrad("distance")}
                            onInput={(e) => props?.setMaxDistance(e.target.value)}
                            label={ControlTrad.getTrad("distance")} />


                    </HeadMain>
                </div>
                <Button onClick={(e) => { close(e); }}>
                    {ControlTrad.getTrad("ok")}
                </Button>
            </Drawer>
        </>
    );

};

export default HeaderFiltersDrawer;